import { QueryClient } from "@tanstack/react-query";

// Single app-wide query cache (ADR-0005 Tier 0). The dashboard fetches whole
// fact collections client-side; caching them removes the refetch-on-filter-
// change / tab-switch / remount storm so the second load onward is instant.
// Per-query staleTime/gcTime are set on each hook; these are conservative
// defaults for everything else.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't refire on window focus — the dashboard data is not real-time.
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: 1,
    },
  },
});
